import { FC } from 'react';
import TextAreaRow from '../TextAreaRow';
import SearchFormItem from './subpage/searchFormItem';
import SearchFormDisabled from './subpage/disabled';
import { getInputPlaceholder } from '../utils/ruleUtils';
import { TextAreaRowProps } from '../TextAreaRow/interface';
import {
  BaseSearchFormItemProps,
  SearchFormItemEnum,
} from './interface/baseInterface';

export interface SearchFormTextAreaRowProps extends BaseSearchFormItemProps {
  /** textAreaRow Props */
  textAreaRowProps?: TextAreaRowProps;
}
/** 多行文本 */
export const SearchFormTextAreaRow: FC<SearchFormTextAreaRowProps> = props => {
  const {
    textAreaRowProps,
    isDetail,
    form,
    render,
    disabledRender,
    isTable,
    name,
    testId,
    label,
    rules,
    copy,
    ...resProps
  } = props;
  return (
    <SearchFormItem
      {...resProps}
      label={label}
      rules={rules}
      disabled={isDetail || textAreaRowProps?.disabled}
      name={name}
    >
      {isDetail || (textAreaRowProps && textAreaRowProps.disabled) ? (
        <SearchFormDisabled
          form={form}
          name={name}
          render={render || disabledRender}
          isTable={isTable}
          copy={copy}
        />
      ) : (
        <TextAreaRow
          test-id={`${testId}-${name}`}
          {...textAreaRowProps}
          placeholder={getInputPlaceholder(label, textAreaRowProps, rules)}
        />
      )}
    </SearchFormItem>
  );
};

SearchFormTextAreaRow.displayName = SearchFormItemEnum.SearchFormTextAreaRow;

export default SearchFormTextAreaRow;
